import React from 'react';
import { useSelector } from '../../store/useSelector';
import { useSearchModule } from '../../hooks/useSearchModule';
import { createListSection } from '../ListSection';
import { SectionItem } from '../SectionItem';
import { Highlight } from '../Highlight';
import { Odds } from '../Odds';
import { LazyImage } from '../LazyImage';
function SelectionElement({ value, highlights, position }) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const searchModule = useSearchModule();
    const selectedSelection = useSelector((state) => state.selectedSelections[value.id]) || {
        fixed: false,
        sp: false,
    };
    const searchSection = 'Selections';
    const sport = ((_a = value.sport) === null || _a === void 0 ? void 0 : _a.slug) || 'selection';
    const href = `${sport}/${encodeURIComponent(value.event.id)}/${value.event.slug}`;
    const sp = value.market.sp;
    const currentPriceNum = value.currentPriceNum;
    const currentPriceDen = value.currentPriceDen;
    const active = Boolean(value.active && currentPriceDen && currentPriceNum);
    const oddsFallback = '-';
    const oddsBase = (React.createElement(Odds, { stopPropagation: true, selected: selectedSelection.fixed, currentPriceNum: currentPriceNum, currentPriceDen: currentPriceDen, fallback: oddsFallback, disabled: !value.active, onClick: () => searchModule.emit('oddClicked', {
            selection: value,
            sp: false,
            status: !selectedSelection.fixed,
            position: position,
            searchSection: searchSection,
        }) }));
    const oddsSp = sp ? (React.createElement(Odds, { stopPropagation: true, selected: selectedSelection.sp, fallback: oddsFallback, sp: true, onClick: () => searchModule.emit('oddClicked', {
            selection: value,
            sp: true,
            status: !selectedSelection.sp,
            position: position,
            searchSection: searchSection,
        }) })) : null;
    const more = !active && sp ? (React.createElement(React.Fragment, null, oddsSp)) : (React.createElement(React.Fragment, null,
        oddsBase,
        oddsSp));
    const title = value.runner ? (React.createElement(React.Fragment, null,
        React.createElement(Highlight, { highlighted: highlights['name'], content: value.name }),
        ' - ',
        React.createElement(Highlight, { highlighted: highlights['market.name'], content: (_b = value.market) === null || _b === void 0 ? void 0 : _b.name }))) : (React.createElement(React.Fragment, null,
        React.createElement(Highlight, { highlighted: highlights['name'], content: value.name })));
    const silkUrl = value.runner
        ? `https://secdn.staticcache.org/sportsbook/silks/${value.runner.silkName}`
        : null;
    const description = value.runner ? (React.createElement(React.Fragment, null,
        silkUrl ? (React.createElement(React.Fragment, null,
            React.createElement(LazyImage, { className: "WhSearch-SectionItem__descriptionIcon", src: silkUrl }),
            ' ')) : null,
        "J: ",
        React.createElement(Highlight, { highlighted: highlights['runner.jockey'], content: value.runner.jockey }),
        ' / ',
        "T: ",
        React.createElement(Highlight, { highlighted: highlights['runner.trainer'], content: value.runner.trainer }),
        React.createElement("br", null),
        React.createElement(Highlight, { highlighted: highlights['event.name'], content: (_c = value.event) === null || _c === void 0 ? void 0 : _c.name }))) : ((_d = value.market) === null || _d === void 0 ? void 0 : _d.name) === ((_e = value.event) === null || _e === void 0 ? void 0 : _e.name) ? (React.createElement(React.Fragment, null,
        React.createElement(Highlight, { highlighted: highlights['event.name'], content: (_f = value.event) === null || _f === void 0 ? void 0 : _f.name }))) : (React.createElement(React.Fragment, null,
        React.createElement(Highlight, { highlighted: highlights['market.name'], content: (_g = value.market) === null || _g === void 0 ? void 0 : _g.name }),
        ' | ',
        React.createElement(Highlight, { highlighted: highlights['event.name'], content: (_h = value.event) === null || _h === void 0 ? void 0 : _h.name })));
    return (React.createElement(SectionItem, { expectedTitle: 1, expectedDescription: 3, className: "WhSearch-SectionItem--selection", more: more, position: position, internalLink: true, id: value.id, href: href, searchSection: searchSection },
        React.createElement("div", { className: "WhSearch-SectionItem__title" }, title),
        React.createElement("div", { className: "WhSearch-SectionItem__description" }, description)));
}
export const SelectionSection = createListSection(SelectionElement, {
    title: 'sectionSelectionsTitle',
});
//# sourceMappingURL=SelectionSection.js.map